import { render, staticRenderFns } from "./TermList.vue?vue&type=template&id=17f4da5f&scoped=true&"
import script from "./TermList.vue?vue&type=script&lang=ts&"
export * from "./TermList.vue?vue&type=script&lang=ts&"
import style0 from "./TermList.vue?vue&type=style&index=0&id=17f4da5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f4da5f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VContainer,VRow,VSpacer})
